import { useState } from "react";
import { X, Loader2, CalendarClock } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function RescheduleModal({ appt, onClose, onDone }) {
  const [date, setDate] = useState(appt.date || "");
  const [time, setTime] = useState(appt.start_time || "10:00");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!date || !time) { toast.error("Pick a date and time."); return; }
    if (date === appt.date && time === appt.start_time) { onClose(); return; }
    setSaving(true);
    try {
      await api.put(`/pos/appointments/${appt.id}/reschedule`, { date, start_time: time });
      toast.success("Appointment rescheduled.");
      onDone?.();
      onClose();
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error((typeof d === "object" ? d?.message : d) || "Could not reschedule");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-[80] bg-black/40 grid place-items-center p-4" onClick={onClose} data-testid="reschedule-modal">
      <div className="bg-white rounded-2xl w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="eyw-label mb-1 flex items-center gap-1.5"><CalendarClock size={13} /> Reschedule</p>
            <h3 className="font-serif text-xl text-[#1A242B]">{appt.service_title || "Appointment"}</h3>
            <p className="text-sm text-[#4A5D6B] mt-0.5">{appt.name || appt.client || "—"}{appt.enhancer_name ? ` · ${appt.enhancer_name}` : ""}</p>
          </div>
          <button onClick={onClose} data-testid="reschedule-close" className="text-[#8FA89B] hover:text-[#1A242B]"><X size={20} /></button>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-medium text-[#1A242B] mb-1 block">Date</label>
            <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="reschedule-date" className="eyw-input w-full" />
          </div>
          <div>
            <label className="text-sm font-medium text-[#1A242B] mb-1 block">Time</label>
            <input type="time" value={time} onChange={(e) => setTime(e.target.value)} data-testid="reschedule-time" className="eyw-input w-full" />
          </div>
        </div>
        {appt.enhancer_name && <p className="text-[11px] text-[#8FA89B] mt-2">We'll re-check {appt.enhancer_name}'s availability across all centers.</p>}
        <button onClick={save} disabled={saving} data-testid="reschedule-save" className="eyw-btn w-full !py-2.5 text-sm mt-4 disabled:opacity-60">
          {saving ? <Loader2 className="animate-spin" size={16} /> : <CalendarClock size={15} />} Save new time
        </button>
      </div>
    </div>
  );
}
